import React from "react";
import { Controller, useForm } from "react-hook-form";
import { Box, Button, Divider, Grid } from "@mui/material";
import LoadingWrapper from "components/Shared/LoadingWrapper";
import InnerShadowBox from "components/Shared/InnerShadowBox";
import BaseAutocomplete from "components/Shared/Base/BaseAutocomplete";
import { ENTITY_LIST_CONSTANTS } from "data/static";
import { useListListQuery } from "store/services/listService";

const ServiceForm = ({
  serviceDetail = null,
  branchDetail,
  isBusy = false,
  onSubmit = () => {},
  onCancel = () => {},
}) => {
  // React Hook Form setup
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      service: serviceDetail?.services || [], // Prepopulate for editing
    },
  });

  // Fetch services from accountListApi
  const { data: serviceList = [], isLoading: isLoadingServices } = useListListQuery({
    type: ENTITY_LIST_CONSTANTS.BRANCH_SERVICES, // Adjust to your constant for services
    status: "Active",
  });

  // Filter out services already associated with the branch
  const mappedServices = React.useMemo(() => {
    if (!serviceList) return [];
    const branchServices = branchDetail?.services || [];
    return serviceList.filter(
      (item) => !branchServices.some((service) => service._id === item._id)
    );
  }, [serviceList, branchDetail]);

  // Handle form submission
  const handleSubmitService = (data) => {
    const _payload = {
      service: data?.service?.map((item) => item._id), // Send array of service IDs
    };
    onSubmit(_payload);
  };

  return (
    <LoadingWrapper loading={isBusy || isLoadingServices}>
      <InnerShadowBox padding={3}>
        <Grid container spacing={5}>
          <Grid item md={12}>
            <Controller
              name="service"
              control={control}
              rules={{ required: "Please select at least one service." }}
              render={({ field }) => (
                <BaseAutocomplete
                  fullWidth
                  required
                  multiple
                  label="Select Service"
                  loading={isLoadingServices}
                  loadingText="Loading Services..."
                  options={mappedServices}
                  getOptionLabel={(opt) => opt?.name || ""}
                  isOptionEqualToValue={(option, value) => option._id === value._id}
                  value={field.value || []}
                  onChange={(_, data) => field.onChange(data)}
                  error={!!errors.service}
                  helperText={errors?.service?.message}
                />
              )}
            />
          </Grid>
        </Grid>
      </InnerShadowBox>

      <Divider />

      <Box
        paddingX={3}
        paddingY={2}
        gap={2}
        style={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button disabled={isBusy} onClick={onCancel}>
          Cancel
        </Button>

        <Button
          variant="outlined"
          disabled={isBusy}
          onClick={handleSubmit(handleSubmitService)}
        >
          {serviceDetail ? "Update" : "Add"}
        </Button>
      </Box>
    </LoadingWrapper>
  );
};

export default ServiceForm;